import { useText } from '@/components/i18n/hooks'
import { useLocalDate } from '@/hooks/use-local-date'
import { byteFormatter, secondsToHours } from '@/util/formatters/dates'

const Usage = ({ item }: any) => {
  const { formatDate } = useLocalDate()
  const seconds = item.peak_volume + item.off_peak_volume

  const quantityText = useText('Antall: {amount}', { amount: item.quantity })
  const timeText = useText('{amount} stk - {duration}', {
    amount: item.quantity,
    duration: secondsToHours(seconds),
  })

  let text = ''

  if (item.price_type === 'Q') {
    text = quantityText
  }

  if (item.price_type === 'T') {
    text = timeText
  }

  if (item.price_type === 'D') {
    const bytes = item.peak_volume + item.off_peak_volume
    text = byteFormatter(bytes)
  }

  if (item.price_type === 'S') {
    text = formatDate({ date: item.from_period }) + ' - ' + formatDate({ date: item.to_period })
  }

  return <div className="usage">{text}</div>
}

export default Usage
